import { Banner } from '@elfsight/widget-banner/widget';
import { useSettings } from '@wu/widget-core';
import { IMAGE_OR_VIDEO_SLIDE_MIN_HEIGHT } from '../../../../constants';

const DEFAULT_BANNER_SETTINGS = {
  contentAlignment: { position: 'center' },
  contentSpacing: 0
};

export const ImageSlide = ({
  data,
  onSlideLinkClick,
  active,
  isMobile,
  shouldForceMinHeight
}) => {
  const {
    googleAnalytics,
    height,
    mobileHeight,
    editMode,
    widgetToken,
    stretchBackground
  } = useSettings();
  const { image, imageEffect, imageFittingMode, slideLink } = data;

  const finalImageEffect = imageFittingMode === 'fit' ? 'none' : imageEffect;

  const background = {
    type: 'image',
    imageFile: image,
    imageAnimationEffect: finalImageEffect,
    imageFittingMode,
    style: {
      minHeight: shouldForceMinHeight ? IMAGE_OR_VIDEO_SLIDE_MIN_HEIGHT : '100%'
    }
  };

  const derivedHeight = isMobile ? mobileHeight : height;

  return (
    <Banner
      {...DEFAULT_BANNER_SETTINGS}
      bannerLink={slideLink}
      onBannerLinkClick={onSlideLinkClick}
      googleAnalytics={googleAnalytics}
      verticalBannerHeight={derivedHeight}
      bannerBackgroundImageAnimationEffect={imageEffect}
      bannerBackground={background}
      triggerBackgroundImageAnimationEffect={active}
      editMode={editMode}
      widgetToken={widgetToken}
      stretchBackground={stretchBackground}
      style={{ flexBasis: '100%', maxWidth: '100%', marginInline: '0' }}
      blockless
    />
  );
};
